import React, { useState } from 'react';
import { Button } from 'components';
import { renderKr } from 'utils/renderingService';
import PropTypes from 'prop-types';
import { toggleProductBoxContent, getHtml, classList } from 'utils/componentsCommon';
import { ProductTypes } from 'utils/enums';

const ProductBox = ({ product, chooseProductFunc, chooseProductText, elementId, className, fixedTop, orderDescription, ...props }) => {
    const classNames = classList(fixedTop ? 'fixedTop' : '', className);
    const [introBoxVisible, setIntroBoxVisible] = useState(product.introBox?.title);
    const [chooseProductTextValue, setChooseProductTextValue] = useState(chooseProductText);

    const hideIntroBox = () => {
        setIntroBoxVisible(false);
        setChooseProductTextValue('Videre');
        setTimeout(() => toggleProductBoxContent(elementId), 100);
    };
    const longTitleFormatter = (title) => {
        if (!title) {
            return '';
        }
        if (title === 'Nedsparingsrådgivning') {
            return 'Nedsparings rådgivning';
        }
        if (title === 'Investeringsrådgivning') {
            return 'Investerings rådgivning';
        }
        if (title === 'Pensionstjek for selvstændige') {
            return 'Pensionstjek for selv-stændige';
        }
        if (title === 'Lånerådgivning') {
            return 'Låne rådgivning';
        }
        if (title === 'Afklaring ift. nedsparingsrådgivning') {
            return 'Afklaring ift. nedsparings rådgivning';
        }
        if (title === 'Pensionsrådgivning') {
            return 'Pensions rådgivning';
        }
        return title;
    };
    return (
        <>
            { product && (
                <div id={ elementId } className={ classNames } { ...props }>
                    { introBoxVisible ? (
                        <>
                            <div className="title introTitle">
                                <h5>{ product.introBox?.title }</h5>
                            </div>

                            <div className="introText" dangerouslySetInnerHTML={ getHtml(product.introBox?.text) } />
                            <div className="introDivider">
                                <Button color="white" onClick={ () => hideIntroBox() }>
                                    { chooseProductTextValue || (product.cta.text ?? product.cta) || 'Vælg' }
                                </Button>
                            </div>
                        </>
                    ) : (
                        <>
                            <div>
                                <div className="title">
                                    <h5 dangerouslySetInnerHTML={{ __html: longTitleFormatter(product.name) }} ></h5>
                                </div>
                                { product.price ? (
                                    <>
                                        <div className="price">
                                            <div>
                                                { product.type === ProductTypes.Product && (
                                                    <>
                                                        { product.price.now && renderKr(product.price.now, '', 1) }
                                                        { !Number.isInteger(product.price.now) && product.price.standard && renderKr(product.price.standard, '', 1) }
                                                        { product.price.hourly ? <span>kr. / time</span> : <span>kr.</span> }
                                                    </>
                                                ) }
                                                { product.type === ProductTypes.Subscription && (
                                                    product.price.monthly?
                                                        <>
                                                            { product.price.monthly?.now && renderKr(product.price.monthly?.now, '', 1) }
                                                            { !Number.isInteger(product.price.monthly?.now) && product.price.monthly?.standard && renderKr(product.price.monthly?.standard, '', 1) }
                                                            <span>kr. / måned</span>
                                                        </>:
                                                        <>
                                                            { product.price.yearly?.now && renderKr(product.price.yearly?.now, '', 1) }
                                                            { !Number.isInteger(product.price.yearly?.now) && product.price.yearly?.standard && renderKr(product.price.yearly?.standard, '', 1) }
                                                            <span>kr. / år</span>
                                                        </>
                                                ) }
                                            </div>
                                        </div>
                                        <div>
                                            <strong className="highlight">{ product.highlight }</strong>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div dangerouslySetInnerHTML={ getHtml(product.descriptionShort) } />
                                        { orderDescription && <p className="focusTextWhite">{ orderDescription }</p> }
                                    </>
                                ) }
                            </div>
                            { product.price ? (
                                <>
                                    { chooseProductFunc && (
                                        <div className="divider">
                                            <Button color="white" onClick={ (e) => chooseProductFunc(e, product) }>
                                                { chooseProductTextValue || product.cta || 'Vælg' }
                                            </Button>
                                        </div>
                                    ) }
                                    <p className="focusTextWhite" dangerouslySetInnerHTML={ getHtml(product.descriptionShort) }></p>
                                    { orderDescription && <p className="focusTextWhite">{ orderDescription }</p> }
                                    { !props.orderMode && (
                                        <>
                                            <div>
                                                <div className="moreAnchor">
                                                    <a onClick={ () => toggleProductBoxContent(elementId) }>+ Læs mere</a>
                                                </div>
                                                <div className="hidden description" dangerouslySetInnerHTML={ getHtml(product.description) } />
                                            </div>
                                        </>
                                    ) }

                                    { chooseProductFunc && product.introBox?.text && product.type === 'product' && (
                                        <>
                                            <br />
                                            <Button color="white" onClick={ (e) => chooseProductFunc(e, product) }>
                                                { chooseProductTextValue || product.cta || 'Vælg' }
                                            </Button>
                                        </>
                                    ) }
                                </>
                            ) : (
                                <>
                                    <div className="divider"></div>
                                    { product.image && (
                                        <p className="focusTextWhite">
                                            <img className="productImage" src={ product.image } alt={ product.name } />
                                        </p>
                                    ) }
                                    <p className="productInfoTitle hidden">{ product.descriptionTitle }</p>
                                    <div>
                                        <ul>
                                            <div className="moreAnchor">
                                                <a onClick={ () => toggleProductBoxContent(elementId) }>+ Læs mere</a>
                                            </div>
                                            <div className="hidden description" dangerouslySetInnerHTML={ getHtml(product.description) } />
                                        </ul>
                                    </div>
                                    <br className="hidden" />
                                    { chooseProductFunc && (
                                        <>
                                            <br />
                                            <Button color="white" onClick={ (e) => chooseProductFunc(e, product) }>
                                                { chooseProductTextValue || product.cta || 'Vælg' }
                                            </Button>
                                        </>
                                    ) }
                                </>
                            ) }
                        </>
                    ) }
                    { product?.note && props.showNote &&
                    <p className="note" dangerouslySetInnerHTML={{ __html: longTitleFormatter(product.note) }} ></p>
                    }
                </div>
            ) }

        </>
    );
};

ProductBox.propTypes = {
    product: PropTypes.object.isRequired,
    chooseProductFunc: PropTypes.func.isRequired,
    chooseProductText: PropTypes.string,
    title: PropTypes.string,
    priority: PropTypes.string,
    elementId: PropTypes.string,
    fixedTop: PropTypes.bool,
    className: PropTypes.string,
};

export default ProductBox;
